import { useQuery } from "@tanstack/react-query";
import { landlordApi } from "@/api/LandlordApi";

export const useLandlordProfile = ({ staleTime = 0 } = { staleTime: 0 }) =>
  useQuery({
    queryKey: ["landlord-profile"],
    queryFn: () => landlordApi.getProfile(),
    staleTime,
  });
